module.exports = __webpack_public_path__ + "static/media/video.efe62206.webm";